import { render, staticRenderFns } from "./PayVerify.vue?vue&type=template&id=19901bc0"
import script from "./PayVerify.vue?vue&type=script&lang=js"
export * from "./PayVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports